import { StyleSheet } from 'aphrodite';
import { brandPrimaryText, destructive, titles } from '../../../web/styles/colors';
import { cardStyle } from '../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	card: {
		...cardStyle,
		marginBottom: 20,
		padding: '15px 19px',
	},
	container: {},
	delete: {
		color: destructive,
		cursor: 'pointer',
		fontSize: 14,
		textAlign: 'center',
		width: '100%',
	},
	edit: {
		color: brandPrimaryText,
		cursor: 'pointer',
		fontSize: 14,
	},
	text: {
		color: '#4A4A4A',
		display: 'flex',
		fontSize: 12,
		justifyContent: 'space-between',
	},
	title: {
		color: titles,
		fontSize: 16,
		marginBottom: 6,
	},
});
